import './App.css';
import AppRouting from "./app-routing";
import NavBar from "./components/layouts/NavBar";
import {Box, CircularProgress, Container, Toolbar} from "@mui/material";
import {MsalContext, useIsAuthenticated, useMsal} from "@azure/msal-react";
import axios from "axios";
import React, {Component, memo} from "react";
import {connect} from "react-redux";
import {getUserSlackLastTimeThunk, getUserSlackThunk} from "./redux/slack/users/users.thunk";

const App = memo(class extends Component {

    state = {
        // Use a more descriptive name to prevent multiple fetches
        isFetchingInitialUser: false
    }

    static contextType = MsalContext;

    componentDidMount() {
        if (this.props.user?.length > 0) {
            this.setState({loading: false});
        }
        this.props.getUserSlackLastTime();
        this.fetchUserIfAuthenticated();
    }

    componentDidUpdate(prevProps, prevState) {
        // Check if the MSAL authentication context has changed from having no accounts to having accounts.
        // This is the primary trigger to fetch user data.
        // const wasAuthenticated = prevProps.msalContext.accounts.length > 0;
        // const isAuthenticated = this.context.accounts.length > 0;
        //
        // if (isAuthenticated && !wasAuthenticated) {
        //     this.fetchUserIfAuthenticated();
        // }
    }

    fetchUserIfAuthenticated = () => {
        // Conditions to fetch:
        // 1. MSAL context has an account.
        // 2. We don't have user data in Redux yet.
        // 3. We are not already in the process of fetching.
        if (this.context.accounts?.length > 0 && this.props.user && !this.state.isFetchingInitialUser) {
            this.setState({ isFetchingInitialUser: true });
            this.props.getUserSlack(this.context.accounts[0].username);
        }
    }

    render() {
        console.log('render APP')
        return (
            <div className={`min-vh-100 ${this.context.accounts.length === 0 ? this.context.inProgress === 'logout' ? '' : 'bg-light' : ''}`}>
                <NavBar/>
                <Box className="h-100">
                    <Toolbar/>
                    <Container className="mt-md-5">
                        <div className="mx-md-5">
                            {this.props.userStatus === 'loading' ?
                                <div className="text-center col-12">
                                    <p>Loading...</p>
                                    <CircularProgress/>
                                </div>
                                : <AppRouting/>}
                        </div>
                    </Container>
                </Box>

            </div>
        );
    }
});

// Map state to props;
const mapStateToProps = (state) => {
    console.log("state App", state);
    return {
        user: state.users.user,
        selectedUser: state.users.selectedAccount,
        userStatus: state.users.status
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserSlack: (email) => dispatch(getUserSlackThunk(email)),
        getUserSlackLastTime: () => dispatch(getUserSlackLastTimeThunk())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
